<template>
  <section class="article-main">
    <div v-if="article.published !== true" class="article-main__draft">Draft</div>
    <nuxt-content class="article-main__content" :document="article" />
  </section>
</template>

<script>
import ArticleBanner from './articleContent/articleBanner'
import ArticleColumn from './articleContent/articleColumn'
import ArticleColumns from './articleContent/articleColumns'
import ArticleCTA from './articleContent/articleCTA'
import ArticleRow from './articleContent/articleRow'

export default {
  components: {
    /* eslint-disable vue/no-unused-components */
    banner: ArticleBanner,
    column: ArticleColumn,
    columns: ArticleColumns,
    cta: ArticleCTA,
    row: ArticleRow,
  },
  props: {
    /**
     * Article data
     */
    article: {
      required: true,
      type: Object,
    },
  },
}
</script>

<style lang="postcss" scoped>
.article-main {
  /* Ensure portrait images won't be
     taller than screen height */
  & img {
    @apply w-full object-contain object-center;
    max-height: calc(75vh - 100px);
  }
  & figcaption {
    letter-spacing: 0;
    /* Image caption shouldn't have indenting since it's centred */
    text-indent: 0;
  }

  & .article-main__draft {
    @apply flex fixed font-bold uppercase;
    @apply text-white bg-red shadow;
    @apply z-10 pointer-events-none;
    padding: 0 1.25em;
    font-size: inherit;
    line-height: 2.5;
  }
}

/* Iframe container */
.article-iframe {
  @apply relative w-full;

  & iframe {
    @apply absolute w-full h-full z-1;
  }
  & .article-iframe__placeholder {
    @apply block w-full pointer-events-none z-0;
  }
}

@screen mobile {
  .article-main {
    & .article-main__draft {
      @apply rounded;
      bottom: 1rem;
      right: 1rem;
    }
  }
}

@screen desktop {
  .article-main {
    & .article-main__draft {
      @apply rounded-md;
      bottom: 1.5rem;
      right: calc(50% - 480px);
    }
  }
}
</style>
